export enum PropertyStrategyComponentType {
  Input = 'input',
  Dropdown = 'dropdown',
  Other = 'other',
}
